<template>
    <div class="p-6 bg-white rounded-2xl w-full h-full shadow-custom">
        <slot />
    </div>
</template>